<template>
  <div class="questionnairessss">
    <div v-if="subjects.is_answer === 2 || subjects.is_answer === 3 " class="content">
      <li v-for="(item,index) in subjects.data" :key="index">
        <div class="top">{{item.nub}}.{{item.title}} (
          <span v-if="item.type === 1">单选</span>
          <span v-if="item.type === 2">多选 </span>
          <span v-if="item.type === 3">文本输入</span>
          <span v-if="item.type === 4">上传文件</span>
          )
        </div>
        <div v-if="item.type === 1" class="radio">
          <div v-if="subjects.is_answer === 3" class="subjectsHUIxian">上次选择：<span>{{item.teacher_answer}}</span></div>
          <div class="label supportTbody" v-for="(items, indexs) in item.option" :key="indexs">
            <div @click="answerRadio(index,items.test_id,items.id)">
              <!--              <input :id="'radio' + items.test_id + indexs" type="radio" :name="'radio' + items.test_id"-->
              <!--                     :value="items.id"/>-->
              <!--              <label :for="'radio' + items.test_id + indexs">{{items.describe}}</label>-->
              <label :for="'radio' + items.test_id + indexs">
                <input :id="'radio' + items.test_id + indexs" type="radio" :name="'radio' + items.test_id"
                       :value="items.id"/>
                <i></i>
                <span style="margin: 0 0 0 3px">{{items.name}}</span>
                <b>{{items.describe}}</b>
              </label>
            </div>
          </div>
        </div>
        <div v-if="item.type === 2" class="checkbox">
          <div v-if="subjects.is_answer === 3" class="subjectsHUIxian">上次选择：<span>{{item.teacher_answer}}</span></div>
          <div class="label supportTbody" v-for="(items, indexs) in item.option" :key="indexs">
            <div @click="answerCheckbox(index,indexs,items.test_id,items.id,$event)">
              <!--              <input :class="'radio' + items.test_id + indexs" :id="'radio' + items.test_id + indexs" type="checkbox"-->
              <!--                     :name="'radio' + items.test_id"-->
              <!--                     :value="items.id"/>-->
              <!--              <label :for="'radio' + items.test_id + indexs">{{items.describe}}</label>-->
              <label :for="'radio' + items.test_id + indexs">
                <input :class="'radio' + items.test_id + indexs" :id="'radio' + items.test_id + indexs" type="checkbox"
                       :name="'radio' + items.test_id"
                       :value="items.id"/>
                <i>✓</i>
                <span style="margin: 0 0 0 3px">{{items.name}}</span>
                <b>{{items.describe}}</b>
              </label>
            </div>
          </div>
        </div>
        <div v-if="item.type === 3" class="textarea">
          <textarea @input="descInput(index,item.id,$event)" placeholder="请输入内容">{{item.teacher_answer}}</textarea>
        </div>
        <div v-if="item.type === 4" class="file">
          <div v-if="subjects.is_answer">上次回答： <span v-for="(s,v) in item.teacher_answer" :key="v">{{s}}</span></div>
          <input type="file" class="upload" @change="addImg(index,item.id,$event)" id="upload-ele"/>
        </div>
      </li>
      <div v-if="New_Progress" class="New_Progress">
        <el-progress color="#ff8484" type="circle" class="dsadas" :percentage="complete"></el-progress>
      </div>
      <div @click="addtest" class="sure">提交</div>
    </div>
    <div v-if="subjects.is_answer === 1" class="content">
      <li v-for="(item,index) in subjects.data" :key="index">
        <div class="top">
          {{item.nub}}.{{item.title}}(
          <span v-if="item.type === 1">单选</span>
          <span v-if="item.type === 2">多选 </span>
          <span v-if="item.type === 3">文本输入</span>
          <span v-if="item.type === 4">上传文件</span>
          )

          <span class="true_answer" v-if="item.type === 1 || item.type === 2">
            正确选项：{{item.true_answer}}
          </span>

        </div>
        <div v-if="item.type === 1" class="radio">
          <div class="label supportTbody" v-for="(items, indexs) in item.option" :key="indexs">
            <div @click="answerRadio(index,items.test_id,items.id)">
              <!--              <input :id="'radio' + items.test_id + indexs" type="radio" :name="'radio' + items.test_id"-->
              <!--                     :value="items.id"/>-->
              <!--              <label :for="'radio' + items.test_id + indexs">{{items.describe}}</label>-->
              <label :for="'radio' + items.test_id + indexs">

                <input :id="'radio' + items.test_id + indexs" :checked=" items.teacher_answer === 1 "
                       type="radio" disabled :name="'radio' + items.test_id"
                       :value="items.id"/>
                <i></i>
                <span style="margin: 0 0 0 3px">{{items.name}}</span>
                <b>&nbsp;{{items.name}},&nbsp;&nbsp;{{items.describe}}</b>
              </label>
            </div>
          </div>
        </div>
        <div v-if="item.type === 2" class="checkbox">
          <div class="label supportTbody" v-for="(items, indexs) in item.option" :key="indexs">
            <div @click="answerCheckbox(index,indexs,items.test_id,items.id,$event)">
              <!--              <input :class="'radio' + items.test_id + indexs" :id="'radio' + items.test_id + indexs" type="checkbox"-->
              <!--                     :name="'radio' + items.test_id"-->
              <!--                     :value="items.id"/>-->
              <!--              <label :for="'radio' + items.test_id + indexs">{{items.describe}}</label>-->
              <label :for="'radio' + items.test_id + indexs">
                <input :class="'radio' + items.test_id + indexs" :id="'radio' + items.test_id + indexs" type="checkbox"
                       :name="'radio' + items.test_id" disabled :checked=" items.teacher_answer === 1 "
                       :value="items.id"/>
                <i>✓</i>
                <span style="margin: 0 0 0 3px">{{items.name}}</span>
                <b>&nbsp;{{items.name}},&nbsp;&nbsp;{{items.describe}}</b>
              </label>
            </div>
          </div>
        </div>

        <div v-if="item.type === 3" class="true_textarea">
          <div style="width: 40%" class="textarea fl">
            <textarea readonly :value="item.teacher_answer" placeholder="请输入内容"></textarea>
          </div>
          <div style="width: 40%" class="textarea fr">
            <textarea readonly :value="item.true_content" placeholder="请输入内容"></textarea>
          </div>
        </div>
        <div v-if="item.type === 4" class="file">
          <div class="trueTit">正确答案</div>
          <div class="trueUrl line-clamp-1" @click="download(item.true_content)">
            {{item.true_content}}
          </div>
          <div class="mytit">我的上传</div>
          <div class="url line-clamp-1" v-for="(items, indexs) in item.teacher_answer"
               :key="indexs">
            {{indexs}}},{{items}}
          </div>
        </div>
      </li>
      <div v-if=" subjects.completion_score !== '' " class="completion_score">{{subjects.completion_score}}分</div>
      <div class="appraise">{{subjects.appraise}}</div>
      <!--      <div @click="addtest" class="sure">提交</div>-->
    </div>
  </div>
</template>

<script>
  let partupload_upload_id = ''
  let partupload_object = ''
  let partupload_file = ''

  // import axios from 'axios'

  export default {
    props: {
      subjects: {
        type: Object
      }
    },
    data () {
      return {
        answer: [],
        htmlTime: 0,
        id: 0,
        timer: null,
        New_Progress: false,
        complete: 0,
        timersss: null,
        typeDuoxuan: true // 多选重置答案
      }
    },
    created () {
      this.id = this.$parent.id
      this.timer = setInterval(res => {
        this.htmlTime++
      }, 1000)
      for (let i = 0; i < this.subjects.data.length; i++) {
        var val = []
        var key
        if (this.subjects.data[i].type === 2) {
          if (!this.subjects.data[i].teacher_answer) {
            val = []
          } else {
            var teacher_answer = this.subjects.data[i].teacher_answer.split(',')
            console.log(teacher_answer)
            for (let x = 0; x < this.subjects.data[i].option.length; x++) {
              for (let y = 0; y < teacher_answer.length; y++) {
                if (teacher_answer[y] === this.subjects.data[i].option[x].name) {
                  val.push(this.subjects.data[i].option[x].id)
                  key = this.subjects.data[i].id
                }
              }
            }
          }
        } else if (this.subjects.data[i].type === 1) {
          if (!this.subjects.data[i].teacher_answer) {
            val = []
          } else {
            for (let x = 0; x < this.subjects.data[i].option.length; x++) {
              if (this.subjects.data[i].option[x].name == this.subjects.data[i].teacher_answer) {
                val.push(this.subjects.data[i].option[x].id)
                key = this.subjects.data[i].id
              }
            }
          }
        } else if (this.subjects.data[i].type === 3) {

          if (!this.subjects.data[i].teacher_answer) {
            val = ''
          } else {
            val = this.subjects.data[i].teacher_answer
            key = this.subjects.data[i].id
          }
        } else {

          if (!this.subjects.data[i].teacher_answer) {
            val = ''
          } else {
            val = this.subjects.data[i].teacher_answer[0]
            key = this.subjects.data[i].id
          }
        }
        this.answer.push({
          key: key,
          val: val
        })
      }
      if (this.subjects.is_answer === 3) {
        this.$message({
          message: '你已经答过题了，请等待审核',
          type: 'success',
          duration: 2000
        })
      }

      this.$http.post('/apipx/tool/upparam', {
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        this.client = new OSS.Wrapper({
          region: 'oss-cn-shenzhen',
          secure: true,
          accessKeyId: res.data.Credentials.AccessKeyId,
          accessKeySecret: res.data.Credentials.AccessKeySecret,
          stsToken: res.data.Credentials.SecurityToken,
          bucket: 'jianxu-oss01'
        })
      })
    },
    destroyed () {
      this.$http.post('/apipx/Lesson/studyrecord', {
        lesson_id: this.id,
        time_lenght: this.htmlTime,
        num: 0,
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        clearInterval(this.timer)
      })
    },
    methods: {
      answerRadio (index, testId, id) { // 单选选择
        this.answer[index].val[0] = id
        this.answer[index].key = testId
      },
      answerCheckbox (index, indexs, testId, id, $event) { // 多选
        if (this.typeDuoxuan) {
          this.answer[index].val = []
        }
        let as = this.answer[index].val
        if ($event.target.checked) {
          as [indexs] = id
          this.answer[index].val = as
          this.answer[index].key = testId

        } else {
          this.answer[index].val[indexs] = ''
        }
        this.typeDuoxuan = false
        // console.log(this.answer)
      },
      download (url) { // 下载文件
        window.open(url, '_blank')
        window.close()
      },
      pushFile (file, id, index) {
        console.log(file)
        let that = this
        let _file = file
        let fileName = file.name.lastIndexOf('.')
        let fileNameLength = file.name.length
        let fileFormat = file.name.substring(fileName, fileNameLength)
        let fileFormat_a = file.name.substring(0, fileName)
        var storeAs = fileFormat_a + '-' + (new Date()).getTime() + fileFormat // 传到oss上的名字
        // 调用上传方法endpoint
        that.client.multipartUpload('cloudStorage/' + storeAs, _file, {
          progress: function * (percentage) {
            let fileloadingNum = percentage.toFixed(2) * 100
            that.New_Progress = true
            that.complete = fileloadingNum
            console.log(fileloadingNum) // 上传文件进度
          }
        }).then(function (result) {
          that.answer[index].val = 'http://jianxu-oss01.oss-cn-shenzhen.aliyuncs.com/cloudStorage/' + storeAs
          that.answer[index].key = id
          that.New_Progress = false

        }).catch(function (err) {
          console.log(err)
          that.New_Progress = false
          that.$message({
            message: '上传错误，请重新上传',
            type: 'error',
            duration: 2000
          })
        })
      },
      addImg (index, id, e) { // 上传文件
        for (let i = 0; i < e.target.files.length; i++) {
          this.pushFile(e.target.files[i], id, index)
        }
        // const that = this
        // let file = e.target.files
        //
        // var adds = []
        // for (let i = 0; i < file.length; i++) {
        //
        //   adds.push({
        //     name: file[i].name,
        //     size: file[i].size
        //   })
        // }
        //
        // this.$http.post('/apipx/Tool/partupload', {
        //   type: 'image',
        //   group: 'user',
        //   method: 'part',
        //   file: adds,
        //   token: JSON.parse(localStorage.getItem('login')).token
        // }).then(res => {
        //   if (res.code === 0) {
        //
        //     partupload_upload_id = res.data[0].upload_id
        //     partupload_object = res.data[0].object
        //     partupload_file = res.data[0].file
        //
        //     let config = {
        //       headers: {'Content-Type': 'multipart/form-data'},
        //       loding: true,
        //       onUploadProgress: progressEvent => {
        //         that.New_Progress = true
        //         that.complete = parseInt((progressEvent.loaded / progressEvent.total * 100 | 0) * 0.2)
        //         if (that.complete === 20) {
        //           that.timersss = setInterval(function () {
        //             axios.get('https://superteacherpi.jianxuedu.com/apipx/Tool/getpartUploadList', {
        //               params: {
        //                 file: partupload_file,
        //                 upload_id: partupload_upload_id,
        //                 object: partupload_object,
        //                 token: JSON.parse(localStorage.getItem('login')).token
        //               }
        //             }).then((ress) => {
        //               that.complete = (((ress.data.data.success_num / ress.data.data.all_num).toFixed(2) * 100) * 0.8) + 20
        //               if (that.complete === 100) {
        //                 clearInterval(that.timersss)
        //               }
        //             })
        //
        //             // that.$http.post('/apipx/Tool/getpartUploadList', {
        //             //   file: partupload_file,
        //             //   upload_id: partupload_upload_id,
        //             //   object: partupload_object,
        //             //   token: JSON.parse(localStorage.getItem('login')).token
        //             // }).then(res => {
        //             //   if (res.code === 0) {
        //             //     that.complete = parseInt((res.data.success_num / res.data.all_num) * 100)
        //             //     that.complete = '2/' + that.complete
        //             //     if (that.complete === '2/100') {
        //             //       clearInterval(that.timersss)
        //             //     }
        //             //   }
        //             // })
        //           }, 1000)
        //         }
        //       }
        //     }
        //     that.New_Progress = false
        //     let formData = new FormData()
        //     var add = []
        //     for (let i = 0; i < file.length; i++) {
        //       add.push(file[i])
        //     }
        //     add.forEach(function (i, index) {
        //       formData.append('file' + index, i)
        //     })
        //     formData.append('type', 'image')
        //     formData.append('group', 'user')
        //     formData.append('method', 'post')
        //     formData.append('upload_id', partupload_upload_id)
        //     formData.append('object', partupload_object)
        //     formData.append('token', JSON.parse(localStorage.getItem('login')).token)
        //     this.$http.post('/apipx/Tool/completePartUpload', formData, config).then(function (res) {
        //       if (res.code === 0) {
        //         that.New_Progress = false
        //         clearInterval(that.timersss)
        //         that.answer[index].val = res.data.src[0]
        //         that.answer[index].key = id
        //       }
        //     })
        //   }
        // })
      },
      getpartUploadList (file, upload_id, object) {
        this.$http.post('/apipx/Tool/getpartUploadList', {
          file: file,
          upload_id: upload_id,
          object: object,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.complete = ((res.data.success_num / res.data.all_num) * 100).toFixed(2)
          }
        })
      },
      descInput (index, id, $event) {
        this.answer[index].val = $event.target.value
        this.answer[index].key = id
      },
      addtest () {
        for (let i = 0; i < this.answer.length; i++) { // 循环第一层判断单选 多选
          if (typeof (this.answer[i].val) === 'object') {
            let arr = false
            for (let x = 0; x < this.answer[i].val.length; x++) { // 循环第二判断搜狗有值
              if (this.answer[i].val[x] !== '') {
                arr = true
              }
            }
            if (!arr) {
              this.$message({
                message: '请回答第' + (i + 1) + '题',
                type: 'error',
                duration: 2000
              })
              return false
            }
          } else {
            if (this.answer[i].val === '') {
              this.$message({
                message: '请回答第' + (i + 1) + '题',
                type: 'error',
                duration: 2000
              })
              return false
            }
          }
        }
        this.$http.post('/apipx/Lesson/addtest', {
          lesson_id: this.$parent.id,
          answer: this.answer,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '答题成功',
              type: 'success',
              duration: 2000
            })
            this.$parent.complete()
            this.$parent.subjectFalse = false
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .questionnairessss {
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
    background-color: #fff;

    .subjectsHUIxian {
      margin: 0px 0 10px 0;

      span {
        color: #ff8484;
      }
    }

    .appraise {
      text-align: right;
      line-height: 40px;
    }

    .completion_score {
      text-align: right;
      line-height: 40px;
      color: #ff8484;
      margin-top: 10px;
    }

    .content {
      overflow: hidden;
      width: 80% !important;
      margin: 0 auto;
    }

    .New_Progress {
      width: 100%;
      height: 100%;
      line-height: 100%;
      text-align: center;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 9999;
      background: rgba(255, 255, 255, 0.8);
    }

    .el-progress--circle {
      width: 126px;
      height: 126px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -63px 0 0 -63px;
    }

    .label {
      float: left;
      margin: 0 10px;
    }

    .textarea {
      padding: 20px;
      border: 1px solid #ccc;
      width: 80%;
      border-radius: 10px;

      textarea {
        -webkit-appearance: textarea;
        border: 0;
        width: 100%;
        height: 100px;

        &:focus {
          border: 0;
        }
      }
    }

    .true_textarea {
      .fl {
        &:last-child {
          margin-left: 20px;
          color: #ff8484;
          border: 1px solid #ff8484;
        }
      }
    }

    .sure {
      margin: 20px auto;
      border-radius: 10px;
      cursor: pointer;
      width: 200px;
      height: 40px;
      line-height: 40px;
      background-color: #ff8484;
      text-align: center;
      color: #fff;
    }

    .tit {
      font-size: 20px;
      text-align: center;
      margin: 40px auto 0;
    }

    li {
      overflow: hidden;
      text-align: left;
      font-size: 16px;
      margin-top: 20px;

      .top {
        margin: 10px auto;
      }

      textarea {
        &:focus {
          border: 1px solid #ff827b;
        }

        &:disabled {
          background-color: #fff;
        }
      }
    }

    .true_answer {
      color: #ff827b;
      margin: 0 0 0 10px;
    }

    .file {
      .mytit {
        margin-top: 15px;
      }

      .url {
        font-size: 12px;
        margin-top: 10px;
        color: #aaa;
        cursor: pointer;
      }

      .trueTit {
        margin-top: 15px;
        color: #ff827b;
      }

      .trueUrl {
        font-size: 12px;
        margin-top: 10px;
        color: #ff827b;
        cursor: pointer;
      }
    }

    .supportTbody label b {
      font-size: 14px;
      font-weight: normal;
    }

    .supportTbody label i {
      font-size: 12px;
      font-style: normal;
      display: inline-block;
      width: 13px;
      height: 13px;
      text-indent: 2px;
      line-height: 15px;
      color: #fff;
      margin: 0 0px 0 0px;
      border: #dcdfe6 1px solid;
    }

    .supportTbody input[type="radio"] + i {
      border-radius: 50%;
    }

    .supportTbody input[type="radio"]:checked + i {
      background: #fff;
      border: 1px solid #ff827b;
      position: relative;
    }

    .supportTbody input[type="radio"]:checked + i:after {
      content: '';
      width: 7px;
      height: 7px;
      position: absolute;
      top: 3px;
      left: 3px;
      background: #ff827b;
      border-radius: 50%;
    }

    .supportTbody input[type="checkbox"], .supportTbody input[type="radio"] {
      display: none;
    }

    .supportTbody input[type="checkbox"] + i {
      border-radius: 3px;
    }

    .supportTbody input[type="checkbox"]:checked + i {
      background: #ff827b;
      border: 1px solid #ff827b;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/questionnaire/questionnaire.vue